import type { Router } from 'vue-router';

/**
 * Represents the symbol for the RouterService.
 */
export const RouterService = Symbol.for('RouterService');

/**
 * Represents a router service that extends VueRouter.
 */
export interface RouterService extends Router {}
